module.exports = __webpack_public_path__ + "media/assets/images/login_ace-d8d0d76ad8e0c6f85c0c521d3a42720f.png";